import TermSet from '@rdfjs/term-set';
import * as Path from './path.js';
class FindNodesVisitor extends Path.PathVisitor {
    visitSequencePath({ paths }, { pointer }) {
        return paths.reduce((previous, path) => {
            return pointer.node(path.accept(this, { pointer: previous }));
        }, pointer).terms;
    }
    visitInversePath({ path }, { pointer }) {
        if (path instanceof Path.PredicatePath) {
            return pointer.in(path.term).terms;
        }
        throw new Error('Only inverse of Predicate Paths is implemented');
    }
    visitAlternativePath({ paths }, arg) {
        return paths.flatMap(path => {
            return path.accept(this, arg);
        });
    }
    visitZeroOrOnePath({ path }, { pointer }) {
        return [...pointer.terms, ...path.accept(this, { pointer })];
    }
    visitOneOrMorePath(path, { pointer }) {
        return this.greedyPath(path, pointer);
    }
    visitZeroOrMorePath(path, { pointer }) {
        return [
            ...pointer.terms,
            ...this.greedyPath(path, pointer),
        ];
    }
    greedyPath({ path }, pointer) {
        const remaining = [...pointer.terms];
        const results = new TermSet();
        let current = remaining.pop();
        while (current) {
            const nextNodes = path.accept(this, { pointer: pointer.node(current) });
            for (const nextNode of nextNodes) {
                if (!results.has(nextNode)) {
                    remaining.push(nextNode);
                    results.add(nextNode);
                }
            }
            current = remaining.pop();
        }
        return [...results];
    }
    visitPredicatePath({ term }, { pointer }) {
        return pointer.out(term).terms;
    }
}
/**
 * Finds all nodes connected to the input node by following a [SHACL Property Path](https://www.w3.org/TR/shacl/#dfn-shacl-property-path)
 *
 * @param pointer starting node
 * @param shPath SHACL Property Path
 */
export function findNodes(pointer, shPath) {
    let path;
    if ('termType' in shPath) {
        path = Path.fromNode(pointer.node(shPath));
    }
    else if ('value' in shPath) {
        path = Path.fromNode(shPath);
    }
    else {
        path = shPath;
    }
    const terms = new FindNodesVisitor().visit(path, { pointer });
    return pointer.node([...new TermSet(terms)]);
}
//# sourceMappingURL=findNodes.js.map